import React from 'react';
import './index.css';

export default class Tutorial extends React.Component {

  constructor(props) {
    super(props);
    this.obstacle = React.createRef();
    this.state = { 
      text:''
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      console.log('new word')
      let len = document.getElementById("text").childElementCount
        for (let i = 0; i < len; i++) {
          document.getElementById('text_'+i).style.color = 'black';
        }
    }
  }


//style={{left : this.state.xPos}}
//onKeyDown={this.handleKeyDown} -add back for old functionality
  render() {
    return (
      <div id="tutorial">
        {
          this.props.difficulty < 3 ?
            <div id="tutorialText">
              <h2>Type the letter to jump</h2>
            </div> :
            <div id="tutorialText">
              <h2>Type the above word then space to jump</h2>
            </div>            
        }
      </div>

    );
  }
}
